import { render, staticRenderFns } from "./addCustomer.vue?vue&type=template&id=5cfa7d56&scoped=true"
import script from "./addCustomer.vue?vue&type=script&lang=js"
export * from "./addCustomer.vue?vue&type=script&lang=js"
import style0 from "./addCustomer.vue?vue&type=style&index=0&id=5cfa7d56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa7d56",
  null
  
)

export default component.exports